export const defaultResults = [
  {
    name: 'Todos',
    city: 'Belo Horizonte',
    group: 'BHZ',
    iata: 'BHZ',
    country: 'BR'
  },
  {
    name: 'Todos',
    city: 'São Paulo',
    group: 'SAO',
    iata: 'SAO',
    country: 'BR'
  },
  {
    name: 'Todos',
    city: 'Rio de Janeiro',
    group: 'RIO',
    iata: 'RIO',
    country: 'BR'
  },
  {
    name: 'Salvador',
    city: 'Salvador',
    group: 'SSA',
    iata: 'SSA',
    country: 'BR'
  },
  {
    name: 'Brasília',
    city: 'Brasília',
    group: 'BSB',
    iata: 'BSB',
    country: 'BR'
  }
];
